import {combineReducers} from 'redux';
//import countReducer from './countReducer';
import homeReducer from './homeSlice';
import userReducer from './userContainerSlice';
import globalReducer from './globalSlice';
import otpReducer from './otpContainerSlice';
import profileReducer from './userProfileSlice';
import yellowMessengerReducer from './yellowMessengerSlice';
import customerSearchReducer from './customerSearchSlice';
import storeInformationReducer from './storeInformationSlice';
import otpVerifySlice from './otpVerifySlice';
import offerReducer from './offerSlice';
import checkoutReducer from './checkoutSlice';
import searchItemReducer from './searchItemSlice';
import applyCouponReducer from './applyCouponSlice';
import missSizeApiSlice from './missingSizeApiSlice';
import promoReducer from './instore-promotionsSlice';
import tourGuideSlice from './tourGuideSlice';
import notifyReducer from './notifyCustomerSlice';
import paymentReducer from './paymentSlice';
import orderReducer from './orderSlice';
import metadataReducer from './metadataSlice';
import employeeSignInReducer from './employeeSignInSlice';
import employeeForgetPasswordReducer from './employeeForgetPasswordSlice';
import employeeResetPasswordReducer from './employeeResetPasswordSlice';
import employeeIdSlice from './employeeIdSlice';
import posReducer from './posSlice';
import qrPaymentReducer from './qrPaymentSlice';
import requestLinkPaymentReducer from './requestLinkPaymentSlice';
import feedbackCustomerReducer from './feedbackSlice';
import refreshTokenReducer from './refreshTokenSlice';
import paymentVerificationReducer from './paymentVerificationSlice';
import ordersmsReducer from './ordersmsSlice';
import getCouponReducer from './getCouponSlice';
//insert another reducers here to be combined
const reducers = combineReducers({
  homeReducer,
  userReducer,
  globalReducer,
  otpReducer,
  profileReducer,
  yellowMessengerReducer,
  customerSearchReducer,
  storeInformationReducer,
  otpVerifySlice,
  offerReducer,
  checkoutReducer,
  searchItemReducer,
  applyCouponReducer,
  missSizeApiSlice,
  promoReducer,
  tourGuideSlice,
  notifyReducer,
  paymentReducer,
  orderReducer,
  metadataReducer,
  employeeSignInReducer,
  employeeResetPasswordReducer,
  employeeForgetPasswordReducer,
  employeeIdSlice,
  posReducer,
  qrPaymentReducer,
  requestLinkPaymentReducer,
  feedbackCustomerReducer,
  refreshTokenReducer,
  paymentVerificationReducer,
  ordersmsReducer,
  getCouponReducer,
});

export default reducers;
